import type { ChatMessage as ChatMessageType } from "../../../../shared/types";
import { cn } from "../../lib/utils.ts";
import { timeAgo } from "../../lib/utils.ts";

interface ChatMessageProps {
  message: ChatMessageType;
}

/** Format agent name for display (e.g. "content" -> "Content Agent") */
function formatAgentName(name: string): string {
  return name.charAt(0).toUpperCase() + name.slice(1) + " Agent";
}

export function ChatMessage({ message }: ChatMessageProps) {
  const isUser = message.role === "user";

  return (
    <div
      className={cn(
        "flex w-full",
        isUser ? "justify-end" : "justify-start",
      )}
    >
      <div
        className={cn(
          "max-w-[80%] rounded-2xl px-4 py-3 sm:max-w-[70%]",
          isUser
            ? "bg-indigo-600 text-white"
            : "bg-slate-100 text-slate-900",
        )}
      >
        {/* Agent name badge for AI messages */}
        {!isUser && message.agent_name && (
          <span className="mb-1 inline-block rounded-full bg-slate-200 px-2 py-0.5 text-xs font-medium text-slate-600">
            {formatAgentName(message.agent_name)}
          </span>
        )}

        {/* Message content — render with whitespace preserved */}
        <div className="whitespace-pre-wrap text-sm leading-relaxed">
          {message.content}
        </div>

        {/* Timestamp */}
        <p
          className={cn(
            "mt-1 text-xs",
            isUser ? "text-indigo-200" : "text-slate-400",
          )}
        >
          {timeAgo(message.created_at)}
        </p>
      </div>
    </div>
  );
}
